import { render } from "./BaseLights.vue?vue&type=template&id=fcab84fa"
import script from "./BaseLights.vue?vue&type=script&lang=js"
export * from "./BaseLights.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__